

















import { Vue, Component } from "vue-property-decorator";
import WidgetForm from "@/components/integrations/WidgetForm.vue";
import { Widget as IWidget } from "@/api/models/widget";
import api from "@/getinfo-api";

@Component({ components: { WidgetForm } })
export default class WidgetEdit extends Vue {
  widget!: IWidget;

  data() {
    return {
      widget: undefined
    };
  }

  getWidget() {
    api.WidgetApi.get(this.$route.params.id).then((res: { data: IWidget }) => {
      this.widget = res.data;
    });
  }

  created() {
    this.getWidget();
  }
}
